<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21 6.5h-.3a6 6 0 00-11.2 3v.23a5.44 5.44 0 00-4 5.27 5.49 5.49 0 008.5 4.6V28a1 1 0 002 0v-3.64l2.7-3.24a7.39 7.39 0 002.3.38 7.5 7.5 0 000-15zm-5 14.74v-1.68a7.73 7.73 0 00.85.66zm5-1.74a5.14 5.14 0 01-.88-.08l.65-.78a1 1 0 00-1.54-1.28l-1.1 1.32A5.58 5.58 0 0116 16.35V12.5a1 1 0 00-2 0v4.29A3.5 3.5 0 017.5 15a3.46 3.46 0 013.2-3.46l1.12-.1-.23-1.11A4 4 0 0119.19 8l.3.71.76-.11a4.74 4.74 0 01.75-.1 5.5 5.5 0 010 11z"/></svg>